module.exports = __webpack_public_path__ + "static/media/morralla.edb25b98.svg";